import { AddButton, Header, Page, Toolbox } from 'redesign';
import { useTranslation } from 'react-i18next';
import { WorkflowsTableDataProvider } from './workflows-table';

export function Workflows() {
  const { t } = useTranslation('ogp-screen-specific');

  return (
    <Page
      header={<Header titleText={t('workflows.title', { ns: 'ogp-screen-specific' })} />}
      toolbox={
        <Toolbox>
          <AddButton>{t('workflows.add_workflow', { ns: 'ogp-screen-specific' })}</AddButton>
        </Toolbox>
      }
    >
      <WorkflowsTableDataProvider />
    </Page>
  );
}
